document.addEventListener('click', event => {
  const element = event.target

  if (element.dataset.behavior &&
      element.dataset.behavior.includes('calculate-income-requirement')) {
    const loanAmount          = parseFloat(document.querySelector('[name="loan-amount"]').value.replace(/[$,]+/g, ''))
    const loanLength          = parseFloat(document.querySelector('[name="loan-length"]').value)
    const interestRate        = parseFloat(document.querySelector('[name="interest-rate"]').value)
    const propertyTax         = parseFloat(document.querySelector('[name="property-tax"]').value.replace(/[$,]+/g, ''))
    const mortgageInsurance   = parseFloat(document.querySelector('[name="mortgage-insurance"]').value.replace(/[$,]+/g, ''))
    const autoLoans           = parseFloat(document.querySelector('[name="auto-loans"]').value.replace(/[$,]+/g, ''))
    const creditCards         = parseFloat(document.querySelector('[name="credit-cards"]').value.replace(/[$,]+/g, ''))
    const studentLoans        = parseFloat(document.querySelector('[name="student-loans"]').value.replace(/[$,]+/g, ''))
    const alimonyChildSupport = parseFloat(document.querySelector('[name="alimony-child-support"]').value.replace(/[$,]+/g, ''))
    const otherLoanPayments   = parseFloat(document.querySelector('[name="other-loan-payments"]').value.replace(/[$,]+/g, ''))

    const piti = window.Calculator.getPiti(loanAmount, loanLength, interestRate, propertyTax, mortgageInsurance)
    const totalMonthlyLiabilities = autoLoans + creditCards + studentLoans + alimonyChildSupport + otherLoanPayments
    const monthlyRequiredIncome = window.Calculator.getMonthlyRequiredIncome(piti, totalMonthlyLiabilities)
    const annualRequiredIncome = Math.trunc(monthlyRequiredIncome * 12)
    const resultString = annualRequiredIncome.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    const result = `$ ${resultString}`

    if (element.closest('form').checkValidity()) {
      document.getElementById('income-requirement-result').innerHTML = result
    }
  }
}, false)
